const initalstate = {
    thumbState: 0,
    hasDowngradedBag: false
};

export const ThumbReducer = (state =  initalstate, action) => {
    switch (action.type) {
        case 'CHANGE_THUMB_STATE':
            return {
                ...state,
                thumbState: action.val
            }
        case 'HAS_DOWNGRADE_BAG':
            return {
                ...state,
                hasDowngradedBag: action.val
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/action.tsx